module.exports = __webpack_public_path__ + "img/DW365-262.cb3d9788.jpg";